// MTA-styled avatar set — subway-line roundels + regional-rail badges rendered
// as inline SVG data URIs (license-safe, no external assets). Players pick a
// favorite or upload their own photo.

// Every NYC subway service, grouped by its official bullet color.
const LINES: { label: string; bg: string; fg?: string }[] = [
  { label: "1", bg: "#EE352E" }, { label: "2", bg: "#EE352E" }, { label: "3", bg: "#EE352E" },
  { label: "4", bg: "#00933C" }, { label: "5", bg: "#00933C" }, { label: "6", bg: "#00933C" },
  { label: "7", bg: "#B933AD" },
  { label: "A", bg: "#0039A6" }, { label: "C", bg: "#0039A6" }, { label: "E", bg: "#0039A6" },
  { label: "B", bg: "#FF6319" }, { label: "D", bg: "#FF6319" }, { label: "F", bg: "#FF6319" }, { label: "M", bg: "#FF6319" },
  { label: "G", bg: "#6CBE45" },
  { label: "J", bg: "#996633" }, { label: "Z", bg: "#996633" },
  { label: "L", bg: "#A7A9AC" },
  { label: "N", bg: "#FCCC0A", fg: "#000" }, { label: "Q", bg: "#FCCC0A", fg: "#000" }, { label: "R", bg: "#FCCC0A", fg: "#000" }, { label: "W", bg: "#FCCC0A", fg: "#000" },
  { label: "S", bg: "#808183" },
];

// Commuter / regional rail, as circular agency badges.
const REGIONALS: { id: string; label: string; bg: string; fg?: string }[] = [
  { id: "lirr", label: "LIRR", bg: "#1F4E9B" },
  { id: "mnr", label: "MNR", bg: "#00529B" },
  { id: "njt", label: "NJT", bg: "#F57920", fg: "#000" },
  { id: "amtk", label: "AMTK", bg: "#10437F" },
];

// Letter/number bullets get a big glyph; multi-character agency badges scale down.
function roundel(label: string, bg: string, fg = "#fff"): string {
  const fs = label.length <= 1 ? 52 : label.length <= 2 ? 40 : label.length <= 3 ? 32 : 26;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120"><rect width="120" height="120" fill="#E9DCBE"/><circle cx="60" cy="60" r="44" fill="${bg}"/><text x="60" y="62" font-family="Helvetica,Arial,sans-serif" font-size="${fs}" font-weight="700" fill="${fg}" text-anchor="middle" dominant-baseline="central">${label}</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

export const AVATARS: { id: string; url: string }[] = [
  ...LINES.map((l) => ({ id: `mta-${l.label}`, url: roundel(l.label, l.bg, l.fg) })),
  ...REGIONALS.map((r) => ({ id: `rail-${r.id}`, url: roundel(r.label, r.bg, r.fg) })),
];

// Compress an uploaded image to a small square JPEG data URL (~160px, ≈8 KB).
export function compressImage(file: File, size = 160): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = size; canvas.height = size;
        const ctx = canvas.getContext("2d")!;
        const s = Math.min(img.width, img.height);
        ctx.drawImage(img, (img.width - s) / 2, (img.height - s) / 2, s, s, 0, 0, size, size);
        resolve(canvas.toDataURL("image/jpeg", 0.7));
      };
      img.onerror = reject;
      img.src = reader.result as string;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
